(function(){
  'use strict';
  function boot(){
    var root=document.querySelector('.tll-catalog');
    if(!root||root.dataset.initialized)return;
    root.dataset.initialized='true';
    var data=JSON.parse(root.querySelector('#tll-catalog-data').textContent);
    var gallery=root.querySelector('[data-tll-gallery]');
    var track=gallery.querySelector('.tll-gallery-track');
    var slides=Array.from(track.children);
    var thumbs=Array.from(gallery.querySelectorAll('[data-gallery-index]'));
    var prev=gallery.querySelector('[data-gallery-prev]');
    var next=gallery.querySelector('[data-gallery-next]');
    var counter=gallery.querySelector('.tll-gallery-count');
    var current=0,syncing=false,lastWidth=track.clientWidth;
    function publish(name,detail){try{if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish)Shopify.analytics.publish(name,Object.assign({product_id:String(data.id),lp_version:'catalog_v1'},detail));}catch(e){}}
    function update(index){
      current=Math.max(0,Math.min(slides.length-1,index));
      if(counter)counter.textContent=(current+1)+' / '+slides.length;
      thumbs.forEach(function(b,i){b.setAttribute('aria-current',String(i===current));});
      if(prev)prev.disabled=current===0;if(next)next.disabled=current===slides.length-1;
    }
    function show(index,instant){
      update(index);
      track.scrollTo({left:current*track.clientWidth,behavior:instant||matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    if(prev)prev.addEventListener('click',function(){show(current-1);});
    if(next)next.addEventListener('click',function(){show(current+1);});
    thumbs.forEach(function(b){b.addEventListener('click',function(){show(Number(b.dataset.galleryIndex));});});
    track.addEventListener('scroll',function(){if(track.clientWidth&&track.clientWidth===lastWidth)update(Math.round(track.scrollLeft/track.clientWidth));},{passive:true});
    track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(current+(e.key==='ArrowRight'?1:-1));}});
    function money(c){return '¥'+Math.round(c/100).toLocaleString('ja-JP');}
    function choose(id,user){
      var v=data.variants.find(function(v){return String(v.id)===String(id);});if(!v)return;
      syncing=true;
      root.querySelectorAll('form select[name="id"]').forEach(function(s){var changed=s.value!==String(v.id);s.value=String(v.id);if(changed)s.dispatchEvent(new Event('change',{bubbles:true}));});
      syncing=false;
      root.querySelectorAll('[data-price]').forEach(function(n){n.textContent=money(v.price);});
      root.querySelectorAll('[data-shipping]').forEach(function(n){n.textContent=v.price>=500000?'・送料無料':'';});
      root.querySelectorAll('[data-selected-label]').forEach(function(n){n.textContent=v.title;});
      root.querySelectorAll('[data-variant-card]').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.variantCard===String(v.id)));});
      root.querySelectorAll('[data-add]').forEach(function(b){b.disabled=!v.available;b.textContent=v.available?'カートに追加する':'売り切れ';});
      root.querySelectorAll('[data-checkout]').forEach(function(n){n.hidden=!v.available;});
      root.querySelectorAll('[data-form-status]').forEach(function(n){n.textContent=v.available?'':v.title+'は現在売り切れです。';});
      root.querySelectorAll('input[name="quantity"]').forEach(function(input){
        input.min=String(v.min||1);input.step=String(v.step||1);
        if(v.max!==null&&v.max!==undefined)input.max=String(v.max);else input.removeAttribute('max');
        if(!Number.isFinite(input.valueAsNumber)||input.valueAsNumber<Number(input.min))input.value=input.min;
        if(v.available&&input.max&&input.valueAsNumber>Number(input.max))input.value=input.max;
        input.dispatchEvent(new Event('input',{bubbles:true}));
      });
      var imageIndex=slides.findIndex(function(s){return s.dataset.imageId===String(v.imageId);});if(imageIndex>=0)show(imageIndex,true);
      if(user){var url=new URL(location.href);url.searchParams.set('variant',String(v.id));history.replaceState(null,'',url);publish('techllet_catalog_variant_selected',{variant_id:String(v.id)});}
    }
    root.querySelectorAll('select[name="id"]').forEach(function(s){s.addEventListener('change',function(){if(!syncing)choose(s.value,true);});});
    root.querySelectorAll('[data-variant-card]').forEach(function(b){b.addEventListener('click',function(){choose(b.dataset.variantCard,true);});});
    root.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){f.addEventListener('submit',function(e){
      var v=data.variants.find(function(v){return String(v.id)===f.querySelector('[name="id"]').value;});
      if(!v||!v.available||f.dataset.submitting==='true'){e.preventDefault();return;}
      if(!f.checkValidity()){e.preventDefault();f.reportValidity();return;}
      f.dataset.submitting='true';publish('techllet_catalog_cart_submitted',{variant_id:String(v.id),placement:f.getAttribute('id')});
    });});
    var initial=root.querySelector('select[name="id"]');if(initial)choose(initial.value,false);
    if('ResizeObserver' in window)new ResizeObserver(function(){if(track.clientWidth!==lastWidth){lastWidth=track.clientWidth;show(current,true);}}).observe(track);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
  window.addEventListener('pageshow',function(){document.querySelectorAll('.tll-catalog form').forEach(function(f){delete f.dataset.submitting;});});
})();

(function(){
  "use strict";
  function boot(){
    var section=document.querySelector("[data-tll-recommendations]");
    if(!section || section.dataset.loaded) return;
    section.dataset.loaded="true";
    function load(){
      fetch(section.dataset.url,{credentials:"same-origin"})
        .then(function(response){if(!response.ok)throw new Error("recommendations");return response.json();})
        .then(function(data){
          var products=(data.products||[]).filter(function(p){return String(p.id)!==section.dataset.productId;}).slice(0,4);
          if(!products.length)return;
          var list=document.createDocumentFragment();
          products.forEach(function(p){
            var url=new URL(p.url,location.origin);
            if(url.origin!==location.origin)return;
            var li=document.createElement("li");
            var link=document.createElement("a");link.className="tll-discovery-card";link.href=url.href;
            if(p.featured_image){var img=document.createElement("img");var imageUrl=new URL(p.featured_image,location.origin);imageUrl.searchParams.set("width","600");img.src=imageUrl.href;img.alt=p.title;img.loading="lazy";img.width=600;img.height=600;link.appendChild(img);}
            var heading=document.createElement("h3");heading.textContent=p.title;link.appendChild(heading);
            var price=document.createElement("p");price.className="tll-discovery-price";price.textContent=new Intl.NumberFormat(document.documentElement.lang||"ja-JP",{style:"currency",currency:section.dataset.currency||"JPY",maximumFractionDigits:0}).format(Number(p.price)/100);link.appendChild(price);
            if(!p.available){var soldout=document.createElement("span");soldout.className="tll-discovery-soldout";soldout.textContent=section.dataset.soldoutLabel;link.appendChild(soldout);}
            li.appendChild(link);list.appendChild(li);
          });
          if(list.childNodes.length)section.querySelector(".tll-discovery-grid").replaceChildren(list);
        }).catch(function(){});
    }
    if("IntersectionObserver" in window){var observer=new IntersectionObserver(function(entries){if(entries.some(function(e){return e.isIntersecting;})){observer.disconnect();load();}},{rootMargin:"300px"});observer.observe(section);}else load();
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
  document.addEventListener("shopify:section:load",boot);
})();

(function(){
  "use strict";
  function boot(){
    var syncing=false;
    document.querySelectorAll("#techllet-lp [data-quantity-control]").forEach(function(control){
      if(control.dataset.initialized)return;
      control.dataset.initialized="true";
      var input=control.querySelector("input");
      var minus=control.querySelector('[data-quantity-step="-1"]');
      var plus=control.querySelector('[data-quantity-step="1"]');
      function update(){var value=input.valueAsNumber;minus.disabled=Number.isFinite(value) && value<=Number(input.min||1);plus.disabled=!!input.max && Number.isFinite(value) && value>=Number(input.max);}
      control.querySelectorAll("[data-quantity-step]").forEach(function(button){button.addEventListener("click",function(){
        if(!Number.isFinite(input.valueAsNumber))input.value=input.min||"1";
        else if(button.dataset.quantityStep==="1")input.stepUp();else input.stepDown();
        input.dispatchEvent(new Event("input",{bubbles:true}));input.dispatchEvent(new Event("change",{bubbles:true}));update();
      });});
      function sync(){
        update();
        if(syncing||!input.validity.valid||!Number.isFinite(input.valueAsNumber))return;
        var root=control.closest("#techllet-lp");
        var form=input.form;
        var variant=form&&form.querySelector('[name="id"]');
        if(!root||!variant)return;
        syncing=true;
        root.querySelectorAll('input[name="quantity"]').forEach(function(other){
          var otherVariant=other.form&&other.form.querySelector('[name="id"]');
          if(other===input||!otherVariant||otherVariant.value!==variant.value)return;
          other.value=input.value;
          other.dispatchEvent(new Event("input",{bubbles:true}));
          other.dispatchEvent(new Event("change",{bubbles:true}));
        });
        syncing=false;
      }
      input.addEventListener("input",sync);input.addEventListener("change",sync);update();
    });
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
  document.addEventListener("shopify:section:load",boot);
})();
